const isOutsideOf = (rect: DOMRect, clip: DOMRect): boolean =>
  rect.bottom <= clip.top || rect.top >= clip.bottom || rect.right <= clip.left || rect.left >= clip.right;

const isContainingBlock = (style: CSSStyleDeclaration): boolean =>
  style.position !== 'static' || style.transform !== 'none';

const getClippingParent = (element: HTMLElement): HTMLElement | null => {
  const { position } = window.getComputedStyle(element);

  if (position === 'fixed') {
    return null;
  }

  let parent = element.parentElement;

  if (position === 'absolute') {
    while (parent && !isContainingBlock(window.getComputedStyle(parent))) {
      parent = parent.parentElement;
    }
  }

  return parent;
};

const clipsRect = (parent: HTMLElement, rect: DOMRect): boolean => {
  const { overflowX, overflowY } = window.getComputedStyle(parent);
  const clip = parent.getBoundingClientRect();
  const hasBox = clip.width !== 0 || clip.height !== 0;

  return (overflowX !== 'visible' || overflowY !== 'visible') && hasBox && isOutsideOf(rect, clip);
};

const isClippedByAncestors = (element: HTMLElement): boolean => {
  const rect = element.getBoundingClientRect();

  if (rect.width === 0 && rect.height === 0) {
    return false;
  }

  for (let parent = getClippingParent(element); parent; parent = getClippingParent(parent)) {
    if (clipsRect(parent, rect)) {
      return true;
    }
  }

  return false;
};

export default isClippedByAncestors;
